import React from 'react';
import { useT } from '../../i18n/LocaleContext';

const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export default function RevenueChart({ values, highlightIndex = new Date().getMonth() }) {
  const t = useT();
  return (
    <>
      <div style={{ height: '80px', display: 'flex', alignItems: 'flex-end', gap: '5px', marginBottom: '16px' }}>
        {values.map((h, i) => (
          <div
            key={i}
            className="chart-bar"
            style={{
              flex: 1,
              background: i === highlightIndex ? 'var(--gold)' : 'var(--blue-mid)',
              borderRadius: '3px 3px 0 0',
              height: h + '%',
              opacity: i > highlightIndex ? 0.25 : 1,
              cursor: 'pointer',
              transition: 'opacity 0.15s',
            }}
          />
        ))}
      </div>
      <div style={{ display: 'flex', gap: '5px', marginTop: '4px' }}>
        {MONTH_KEYS.map((m, i) => (
          <div
            key={m}
            style={{
              flex: 1,
              textAlign: 'center',
              fontFamily: "'Cinzel', serif",
              fontSize: '8px',
              color: i === highlightIndex ? 'var(--gold)' : 'var(--text-muted)',
              letterSpacing: '0.5px',
            }}
          >
            {t(`months.abbr.${m}`)}
          </div>
        ))}
      </div>
    </>
  );
}
